import MDBox from "../../components/MDBox";
import { Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { getReservationNoteBookHistory } from "../../api/routes";
import Loading from "../../components/Loading";
import { DataGrid } from "@mui/x-data-grid";
import * as React from "react";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: 600,
  overflow: "auto",
  borderRadius: 4,
  p: 4,
};

function noteBookHistoryField(field) {
  let text;
  switch (field) {
    case "fullname": {
      text = "نام و نام خانوادگی";
      break;
    }
    case "phoneNumber": {
      text = "تلفن همراه";
      break;
    }
    case "description": {
      text = "توضیحات";
      break;
    }
    case "adminUsername": {
      text = "کاربر ثبت کننده";
      break;
    }
    case "isChecked": {
      text = "تایید حضور";
      break;
    }
    case "isAdmission": {
      text = "تایید پرونده";
      break;
    }
    case "del": {
      text = "حذف";
      break;
    }
    case "status": {
      text = "وضعیت";
      break;
    }
    default: {
      text = "";
      break;
    }
  }
  return text;
}


export default function ReservationNoteBookHistoryModal({ modal, handleClose }) {
  const [loading, setLoading] = useState(false);
  const [noteBookHistory, setNoteBookHistory] = useState();
  useEffect(() => {
    if (modal?.item) {
      setLoading(true);
      getReservationNoteBookHistory(modal?.item?.id, (isOk, data) => {
        setLoading(false);
        if (!isOk) {
          return toast.error(data.message);
        } else {
          setNoteBookHistory(data);
        }
      });
    }
  }, [modal?.item]);
  const columns = [
    {
      field: "fieldName",
      headerName: "فیلد",
      width: 160,
      valueGetter: (params) => noteBookHistoryField(params.row.fieldName),
    },
    {
      field: "oldValue",
      headerName: "مقدار قبلی",
      width: 160,
      renderCell: (params) =>
        <p>{params.row.oldValue === "true" ? 1 : params.row.oldValue === "false" ? 0 : params.row.oldValue}</p>,
    },
    {
      field: "newValue",
      headerName: "مقدار جدید",
      width: 160,
      renderCell: (params) =>
        <p>{params.row.newValue === "true" ? 1 : params.row.newValue === "false" ? 0 : params.row.newValue}</p>,
    },
    {
      field: "createdAt",
      headerName: "تاریخ ایجاد",
      width: 200,
      valueGetter: (params) => new Date(params.row.createdAt).toLocaleString("fa-IR"),
    },
  ];

  const rows = noteBookHistory?.map((item, index) => ({ index: index + 1, ...item }));

  return (
    <Modal
      open={modal.state}
      onClose={handleClose}
    >
      <MDBox sx={style}>
        <Loading loading={loading} />
        {noteBookHistory?.length > 0 && <p style={{ fontWeight: "bold", fontSize: 15, marginBottom: 10 }}>
          تاریخچه تغییرات
        </p>}
        {modal?.item && noteBookHistory?.length === 0 && <p>کاربر ثبت کننده: {modal?.item?.adminUsername}</p>}
        {modal?.item && noteBookHistory?.length === 0 &&
          <p style={{ marginTop: 5 }}>تاریخ ثبت: {new Date(modal?.item?.createdAt).toLocaleString("fa-IR")}</p>}
        {!modal?.item && noteBookHistory?.length === 0 && <p>تغییراتی ثبت نشده است</p>}
        {noteBookHistory?.length > 0 && <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(item) => item.id}
          pagination={false}
          autoPageSize={false}
          hideFooter={true}
        />}
      </MDBox>
    </Modal>
  );
}
